export default __webpack_public_path__ + "static/media/Snowboarding.88317f9b.webp";